const initialState = {
  nameUser: localStorage.getItem('username'),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'NAME_USER':
      const { nameUser } = action;
      return {
        ...state,
        nameUser,
      };
    default:
      return state;
  }
};

export const setNameUser = (
  nameUser,
) => ({
  type: 'NAME_USER',
  nameUser,
});
